import React from "react";
import styled from "styled-components";
import { FlexContainer } from "./styled";
import NoDataImage from "../assets/images/noData.png";

const SelectInventoryItemModalContent = ({ items, onSelect }) => {
    if(items.length === 0){
        return <FlexContainer>
          <img src={NoDataImage} alt="No Data" />
        </FlexContainer>
      }
    return (
        <Container>
            {React.Children.toArray(
                items.map((item) => (
                    <ItemContainer onClick={() => onSelect(item)}>
                        <img style={{width:"80%"}} src={item.item.imageUri} alt={item.item.name} />
                        <span>{item.item.name}</span>
                    </ItemContainer>
                ))
            )}
        </Container>
    );
}
const Container = styled.div`
    display:grid;
    grid-template-columns: repeat(4,1fr);
    width: 100%;
    padding: 0 10px;
    gap: 8px;
    max-height: 80vh;
    padding-bottom: 34px;
    overflow-y: auto;
`
const ItemContainer = styled.div`
    width: 100%;
    height: auto;
    aspect-ratio: 859/1320;
    border-radius: 10px;
    background-color:#FFFFFF1A;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: 0px 4px 4px 0px #FFFFFF40 inset;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap:8px;
    span{
        font-size: 12px;
        color: white;
        text-align: center;
    }

`
export default SelectInventoryItemModalContent;